import {
  Component,
  EventEmitter,
  OnChanges,
  Input,
  Output,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateRange } from "@angular/material/datepicker";

interface DateRangee {
  fromDate: string;
  toDate: string;
}

@Component({
  selector: "app-cabinet-datepicker",
  templateUrl: "./cabinet-datepicker.component.html",
})
export class CabinetDatepickerComponent implements OnChanges, OnDestroy {
  @Input() fromDate: string;
  @Input() toDate: string;
  @Output() dateRangeChanged = new EventEmitter<DateRangee>();

  dateRangeFormGroup: FormGroup;
  private destroy$ = new Subject<void>();
  selectedDateRange: DateRange<Date> = new DateRange<Date>(null, null);

  constructor(private formBuilder: FormBuilder) {
    this.dateRangeFormGroup = this.formBuilder.group({
      fromDate: ["", Validators.required],
      toDate: ["", Validators.required],
    });

    this.dateRangeFormGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.selectedDateRange = new DateRange<Date>(
        value.fromDate ? new Date(value.fromDate) : null,
        value.toDate ? new Date(value.toDate) : null,
      );

      if (this.dateRangeFormGroup.valid) {
        this.dateRangeChanged.emit(value);
      }
    });
  }

  getSelectedDateRange(): DateRange<Date> {
    const { fromDate, toDate } = this.dateRangeFormGroup.value;
    return new DateRange(fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null);
  }

  onDateChange(date: string, Dates: "fromDate" | "toDate"): void {
    this.dateRangeFormGroup.get(Dates).setValue(date);
    this.dateRangeFormGroup.get(Dates).markAsTouched();

    if (Dates === "fromDate") {
      this.fromDate = date;
    } else {
      this.toDate = date;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fromDate || changes.toDate) {
      this.dateRangeFormGroup.patchValue(
        {
          fromDate: this.fromDate,
          toDate: this.toDate,
        },
        { emitEvent: true },
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
